import TWEEN from '@tweenjs/tween.js'

export default class DOMImg {
	private readonly id: string
	private readonly keyframes: any
	private readonly tweens: any[] = []
	private readonly el: HTMLElement
	private readonly transform: { top: number; left: number; alpha: number }
	private visible = true

	constructor({ id, keyframes }) {
		this.id = id
		this.keyframes = keyframes
		this.el = document.querySelector(`.js-${id}`)

		this.transform = {
			alpha: 1,
			left: 0,
			top: 0
		}
	}

	init() {}

	resize() {}

	draw() {
		if (!this.visible) return
		this.el.style.transform = `translate3d(${this.transform.left}%, ${this.transform.top}%,0)`
		this.el.style.opacity = `${this.transform.alpha}`
	}

	async animateIn(forward) {
		this.visible = true
		this.el.style.display = 'block'
		const keyframes = this.keyframes ? (forward ? this.keyframes.inForward : this.keyframes.inBackward) : null
		if (keyframes) await this.animate(keyframes)
	}

	async animateOut(forward) {
		const keyframes = this.keyframes ? (forward ? this.keyframes.outForward : this.keyframes.outBackward) : null
		if (keyframes) await this.animate(keyframes)
		this.visible = false
		this.el.style.display = 'block'
	}

	async animate({
		easing = TWEEN.Easing.Linear.None,
		left = () => [0, 0],
		top = () => [0, 0],
		alpha = [1, 1],
		duration = 1500,
		delay = 0
	}) {
		this.tweens.forEach((tween) => tween.stop())
		this.tweens.length = 0

		const x = left()
		const y = top()

		this.transform.left = x[0]
		this.transform.top = y[0]
		this.transform.alpha = alpha[0]

		const to = {
			left: x[1],
			top: y[1],
			alpha: alpha[1]
		}

		return new Promise((resolve) => {
			this.tweens.push(
				new TWEEN.Tween(this.transform)
					.to(to, typeof duration === 'number' ? duration : 1500)
					.delay(typeof delay === 'number' ? delay : 0)
					.easing(typeof easing === 'function' ? easing : TWEEN.Easing.Linear.None)
					.onComplete(resolve)
					.start()
			)
		})
	}

	setAnchor() {}

	preload() {
		return Promise.resolve()
	}
}
